import createComponent from './createComponent'
import createRenderer from './createRenderer'
import FelaProvider from './FelaProvider'
import { Provider, ThemeProvider, connect, withTheme } from 'react-fela'
import StylingProvider from './StylingProvider'
import {renderToMarkup} from 'fela-dom'

export { default as createComponent } from './createComponent'
export { default as createRenderer } from './createRenderer'
export { default as FelaProvider } from './FelaProvider'

export { Provider, ThemeProvider, connect, withTheme } from 'react-fela'
export { default as StylingProvider } from './StylingProvider'
export { renderToMarkup } from 'fela-dom'


export default {
  createComponent,
  createRenderer,
  FelaProvider,
  Provider,
  ThemeProvider,
  connect,
  withTheme,
  StylingProvider,
  renderToMarkup
}
